import React from "react";
import { LocaleProvider } from "./LocaleProvider.js";
function createLocaleHoc(defaultLocale) {
  return function withLocale(WrappedComponent) {
    return function LocaleHOC(props) {
      return /* @__PURE__ */ React.createElement(LocaleProvider, { defaultLocale }, /* @__PURE__ */ React.createElement(WrappedComponent, { ...props }));
    };
  };
}
export {
  createLocaleHoc
};
//# sourceMappingURL=LocaleHOC.js.map
